import React, { useState, useEffect } from 'react';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { 
  FaUserMd,
  FaStethoscope,
  FaLaptopMedical,
  FaFlask
} from 'react-icons/fa';
import './clinical.css';
import { auth, db } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../auth/cache_manager';

function Clinical() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define clinical sections with icons and descriptions
  const clinicalSections = [
    {
      title: 'History Taking',
      icon: <FaUserMd className="ext_cln_section-icon" />,
      description: 'Master medical history taking skills and techniques'
    },
    {
      title: 'Clinical Examination',
      icon: <FaStethoscope className="ext_cln_section-icon" />,
      description: 'Learn systematic physical examination methods'
    },
    {
      title: 'Healthcare Technology',
      icon: <FaLaptopMedical className="ext_cln_section-icon" />,
      description: 'Navigate EPIC and clinical decision support systems'
    },
    {
      title: 'Clinical Investigation',
      icon: <FaFlask className="ext_cln_section-icon" />,
      description: 'Learn about using tools for clinical investigation'
    }
  ];

  return (
    <div className={`ext_cln_page-container ${isDarkMode ? 'ext_cln_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="ext_cln_main-content">
        <div className="ext_cln_header">
          <h1>Clinical Library</h1>
          <p>Essential resources for clinical skills and healthcare technology</p>
        </div>

        <div className="ext_cln_sections-grid">
          {clinicalSections.map((section, index) => (
            <div 
              key={index}
              className="ext_cln_section-card"
            >
              <div className="ext_cln_icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              <div className="ext_cln_coming-soon">Coming Soon</div>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default Clinical; 